import { render, staticRenderFns } from "./DrawerNotificationUser.vue?vue&type=template&id=6b66f2e3&scoped=true"
import script from "./DrawerNotificationUser.js?vue&type=script&lang=js&external"
export * from "./DrawerNotificationUser.js?vue&type=script&lang=js&external"
import style0 from "./DrawerNotificationUser.vue?vue&type=style&index=0&id=6b66f2e3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b66f2e3",
  null
  
)

export default component.exports